import React, { useEffect, useState } from "react";
import { Card, Row, Col, Typography, Tabs, Image, Tooltip } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import moment from "moment";
import { MdWarning } from "react-icons/md";

import { getSingleManager } from "../../../api/AdminRequest";
import BidList from "./BidList";
import AssignedSurvey from "./AssignSurvey";

const { Text } = Typography;
const { TabPane } = Tabs;

const ManagerSingleView = ({ id }) => {
  const [managerDetails, setManagerDetails] = useState("");
  const [loader, setLoader] = useState(true);
  const [surveyAssigned, setSurveyAssigned] = useState(0);
  const [bidApproved, setBidApproved] = useState(0);
  useEffect(() => {
    const singleManagerCall = async () => {
      try {
        const { data } = await getSingleManager(id);
        console.log(data);

        if (data.success) {
          setLoader(false);
          setManagerDetails(data.singleManager);
          setBidApproved(data.approvedBid);
          setSurveyAssigned(data.assignedSurvey);
        } else {
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
      }
    };
    singleManagerCall();
  }, [id]);

  const renderStatus = (status) => (
    <div className="flex items-center">
      <span
        className={`py-1 px-2 rounded-full text-xs ${
          status === "deactive"
            ? "text-red-600 bg-red-100"
            : status === "delete"
            ? "text-gray-600 bg-gray-100"
            : status === "warn1" || status === "warn2"
            ? "text-yellow-600 bg-yellow-100"
            : "text-green-600 bg-green-100"
        }`}
      >
        {status === "deactive"
          ? "Deactivated"
          : status === "delete"
          ? "Deleted"
          : status === "warn1"
          ? "First Warning"
          : status === "warn2"
          ? "Second Warning"
          : "Active"}
      </span>
      {status === "warn1" && (
        <Tooltip title="First Warning">
          <MdWarning className="text-yellow-600 ml-2" />
        </Tooltip>
      )}
      {status === "warn2" && (
        <>
          <Tooltip title="First Warning">
            <MdWarning className="text-yellow-600 ml-2" />
          </Tooltip>
          <Tooltip title="Second Warning">
            <MdWarning className="text-orange-600 ml-2" />
          </Tooltip>
        </>
      )}
    </div>
  );

  return (
    <div className="w-full lg:h-[90vh]  p-4 lg:p-6 md:p-5 bg-white rounded-lg shadow-lg   flex flex-col">
      <div className="flex-grow overflow-y-auto scrollbar-hide">
        <div
          style={{
            padding: "24px",
            // backgroundColor: "#f0f2f5",
            minHeight: "100vh",
          }}
        >
          <Card className="w-full">
            <Row gutter={[16, 16]} className="items-stretch">
              <Col
                xs={24}
                sm={24}
                md={18}
                lg={6}
                xl={4}
                className="flex justify-center  md:justify-start"
              >
                <Image
                  width={155}
                  height={155}
                  src={managerDetails?.profileImage}
                  fallback="data:image/png;base64,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"
                  className="object-cover rounded-lg"
                  style={{
                    border: "2px solid #fff",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={18} lg={8} xl={6}>
                <div className="flex items-center justify-center md:justify-start mb-2">
                  <Text strong className="text-lg">
                    {managerDetails?.name}
                  </Text>
                </div>
                <div className="flex flex-col items-center md:items-start">
                  <div className="flex items-center mb-2">
                    {managerDetails && renderStatus(managerDetails.status)}
                  </div>

                  <Text className="mb-1 flex items-center">
                    <MailOutlined className="mr-2" />
                    <span className="text-blue-500 underline">
                      {managerDetails?.email}
                    </span>
                  </Text>

                  <Text className="mb-1 flex items-center">
                    <PhoneOutlined className="mr-2" />
                    <span className="text-blue-500 underline">
                      {managerDetails?.phone ? managerDetails.phone : "N/A"}
                    </span>
                  </Text>

                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600 mr-4">
                      Joined Date{" "}
                    </span>
                    <span className="font-semibold">
                      {" "}
                      {managerDetails?.createdAt
                        ? moment(managerDetails.createdAt).format(
                            "MMM DD, YYYY"
                          )
                        : "N/A"}
                    </span>
                  </div>
                </div>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <div className="space-y-4">
                  <div className="flex justify-left  text-[16px] text-[#313131] font-semibold border-b border-[#1955EB]">
                    Address Info
                  </div>

                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">State</span>
                    <span className="font-semibold">
                      {managerDetails?.roleDetails?.state.join(", ")}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">District</span>
                    <span className="font-semibold">
                      {managerDetails?.roleDetails?.district.join(", ")}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">City</span>
                    <span className="font-semibold">
                      {managerDetails?.roleDetails?.city.join(", ")}
                    </span>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6} xl={8}>
                <div className="space-y-4">
                  <div className="flex justify-left  text-[#313131] text-[16px] font-semibold border-b border-[#1955EB]">
                    Activity
                  </div>

                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">
                      Total Bidding Approved
                    </span>
                    <span className="font-semibold">
                      {bidApproved?.length || 0}
                    </span>
                  </div>

                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">
                      Total Survey Created
                    </span>
                    <span className="font-semibold">
                      {surveyAssigned?.length || 0}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>

          <Card style={{ marginTop: "24px" }}>
            <Tabs defaultActiveKey="1">
              <TabPane tab="Approved Bid" key="1">
                <BidList bidList={bidApproved} loader={loader} />
              </TabPane>
              <TabPane tab="Created Survey" key="2">
                <AssignedSurvey surveyList={surveyAssigned} loader={loader} />
              </TabPane>
            </Tabs>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ManagerSingleView;
